<template>
    <div>
        <div class="banner-area pd-bottom-100 banner-small-inner banner-small-inner-2">
            <div class="container">
                <div class="row">
                    <div class="col-xl-7 col-lg-9">
                        <h6>¡Bienvenido a Smaco!</h6>
                        
                        <h2> transformación digital para tu empresa</h2>
                    </div>
                    <div class="col-xl-4 offset-xl-1 col-lg-9 mt-3 mt-xl-0 align-self-center">
                        <p style="text-align: justify;">En Smaco, nos dedicamos a ofrecer soluciones de software innovadoras y personalizadas para satisfacer las necesidades de tu negocio.
                             Nuestro enfoque centrado en el cliente y nuestra experiencia en desarrollo de software nos permiten brindarte soluciones de alta calidad que impulsen el éxito y la eficiencia de tu empresa.</p>
                    </div>
                </div>
            </div>
        </div>
     
        <div class="container">
    <div class="banner-video-area banner-video-area-4">
      <div class="banner-slider">
        <div class="slide-item slide-item-1 swiper-slide"></div>
      </div>
      <div class="banner-call">
        Llamanos: +52 (668) 165-3819
      </div>
    </div>
  </div>
</div>
</template>
</template>
<script>
import Swiper from 'swiper';
import 'swiper/swiper-bundle.css';

export default {
  name: "Banner",
  mounted() {
    new Swiper('.banner-slider', {
      slidesPerView: 1,
      slidesPerGroup: 1,
      loop: true,
      speed: 1000,
      pagination: {
        el: '.banner-slider-control .slider-dots',
        clickable: true,
      },
      autoplay: {
        delay: 4000,
      },
    });
  }
};
</script>

<style scoped>
.slide-item-1 {
  background-image: url('~@/assets/img/bg/smaco-6.jpg');
  background-size: cover; 
  background-position: center; 
  height: 100%; 
}

.banner-slider {
  overflow: hidden;
  width: 100%; /* Ancho al 100% del contenedor padre */
}
</style>

<style>
.banner-slider-control-1 .slider-dots .swiper-pagination-bullet {
  margin: 0 12px;
  border: 0;
  background-color: transparent;
  border-radius: 50%;
  width: 16px;
  height: 16px;
  -webkit-transition: all 0.3s ease;
  transition: all 0.3s ease;
  cursor: pointer;
  opacity: 1;
}

.banner-slider-control-1 .slider-dots .swiper-pagination-bullet::before {
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: #0a0909;
  width: 8px;
  height: 8px;
  border-radius: 50%;
}

.banner-slider-control-1 .slider-dots .swiper-pagination-bullet-active {
  border: 1px solid #0a0909;
}
</style>



// WEBPACK FOOTER //
// src/components/page/home/Banner.vue